import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Html from 'slate-html-serializer';
import BlockTypes, { VOID_BLOCKS } from '../../../types/BlockTypes';
import EntityTypes from '../../../types/EntityTypes';
import StyleTypes from '../../../types/StyleTypes';
import { BLOCK, INLINE, MARK } from '../../../types/SlateTypes';
import parseElementDataset from '../../utils/parseElementDataset';
import tagNames from '../utils/tagNames';
import makeDefaultNodeDeserializers from '../utils/makeDefaultNodeDeserializers';
import generateBlockId from '../../utils/generateBlockId';
var BLOCKS = Object.values(BlockTypes);
var ENTITIES = Object.values(EntityTypes);
var MARKS = Object.values(StyleTypes);

var TAGNAME_TO_BLOCK = _objectSpread({}, tagNames.TO_BLOCK);

var TAGNAME_TO_ENTITY = _objectSpread({}, tagNames.TO_ENTITY);

var TAGNAME_TO_MARK = _objectSpread({}, tagNames.TO_MARK);

var defaultNodeDeserializers = makeDefaultNodeDeserializers({
  TAGNAME_TO_BLOCK: TAGNAME_TO_BLOCK,
  TAGNAME_TO_ENTITY: TAGNAME_TO_ENTITY,
  TAGNAME_TO_MARK: TAGNAME_TO_MARK
});
export default function makeDefaultHtmlDeserializer(editor) {
  function nodeDeserializers(el, next) {
    var rules = editor.getDeserializingRules();

    if (el.dataset && el.dataset.type) {
      if (rules[el.dataset.type]) {
        return rules[el.dataset.type](el, next);
      }

      var _parseElementDataset = parseElementDataset(el.dataset),
          type = _parseElementDataset.type,
          data = _objectWithoutProperties(_parseElementDataset, ["type"]);

      var isVoid = VOID_BLOCKS.includes(type);

      if (BLOCKS.includes(type)) {
        return {
          object: BLOCK,
          type: type,
          data: _objectSpread({}, data, {
            id: generateBlockId()
          }),
          nodes: !isVoid ? next(el.childNodes) : undefined
        };
      } else if (ENTITIES.includes(type)) {
        return {
          object: INLINE,
          type: type,
          data: _objectSpread({}, data, {
            entityId: generateBlockId()
          }),
          nodes: next(el.childNodes)
        };
      } else if (MARKS.includes(type)) {
        return {
          object: MARK,
          type: type,
          data: data,
          nodes: next(el.childNodes)
        };
      }
    }

    return defaultNodeDeserializers(el, next);
  }

  return {
    canDeserialize: function canDeserialize(_ref) {
      var type = _ref.type,
          html = _ref.html;
      return type === 'html' && html.length;
    },
    deserialize: function deserialize(_ref2) {
      var rawHtml = _ref2.html;
      var html = rawHtml.replace(/(?:\r\n|\n\r)/g, '\n');
      var deserializer = new Html({
        rules: [{
          deserialize: nodeDeserializers
        }],
        defaultBlock: BlockTypes.UNSTYLED
      });
      return deserializer.deserialize(html);
    }
  };
}